var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.15946C14.0006 6.68247 13.9595 6.2063 13.877 5.73621H7.14172V8.43203H10.9994C10.9205 8.86259 10.7534 9.27302 10.5082 9.6386C10.2631 10.0042 9.94493 10.3173 9.57298 10.5591V12.309H11.8753C13.2233 11.0909 14 9.28948 14 7.15946Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14174 14C9.06909 14 10.6919 13.3798 11.8753 12.3104L9.573 10.5605C8.9322 10.9863 8.1069 11.2294 7.14174 11.2294C5.27887 11.2294 3.69771 9.9986 3.1323 8.34009H0.760559V10.1435C1.355 11.3027 2.26651 12.2773 3.39332 12.9583C4.52013 13.6393 5.8179 14 7.14174 14Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13224 8.3396C2.83332 7.47052 2.83332 6.52938 3.13224 5.6603V3.85693H0.760496C0.260433 4.83217 0 5.9085 0 6.99995C0 8.0914 0.260433 9.16773 0.760496 10.143L3.13224 8.3396Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14174 2.77114C8.16026 2.75483 9.14441 3.13198 9.88149 3.82108L11.9199 1.82327C10.6274 0.633414 8.91496 -0.0198387 7.14174 0.000459239C5.8179 0.000518372 4.52013 0.361186 3.39332 1.0422C2.26651 1.72321 1.355 2.69776 0.760559 3.85705L3.1323 5.66042C3.69771 4.0019 5.27887 2.77114 7.14174 2.77114Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.28d355158f3e02be93922c44dee2262d.svg";
export { ForwardRef as ReactComponent };